var Afghanistan = "Afganistan";
var Albania = "Arnavutluk";
var Algeria = "Cezayir";
var Andorra = "Andorra";
var Angola = "Angola";
var Anguilla = "Anguilla";
var Antarctica = "Antarktika";
var Argentina = "Arjantin";
var Armenia = "Ermenistan";
var Aruba = "Aruba";
var Australia = "Avustralya";
var Austria = "Avusturya";
var Azerbaijan = "Azerbaycan";
var Bahamas = "Bahamalar";
var Bahrain = "Bahreyn";
var Bangladesh = "Bangladeş";
var Barbados = "Barbados";
var Belarus = "Belarus";
var Belgium = "Belçika";
var Belize = "Belize";
var Benin = "Benin";
var Bermuda = "Bermuda";
var Bhutan = "Butan";
var Bolivia = "Bolivia";
var Botswana = "Botsvana";
var Brazil = "Brezilya";
var Bulgaria = "Bulgaristan";
var Burundi = "Burundi";
var Cambodia = "Kamboçya";
var Cameroon = "Kamerun";
var Canada = "Kanada";
var Chad = "Çad";
var Chile = "Şili";
var China = "Çin";
var Colombia = "Kolombiya";
var Comoros = "Komorolar";
var Congo = "Kongo";
var Croatia = "Hırvatistan";
var Cuba = "Küba";
var Cyprus = "Kıbrıs";
var Denmark = "Danimarka";
var Djibouti = "Cibuti";
var Dominica = "Dominik";
var Ecuador = "Ekvador";
var Egypt = "Mısır";
var Eritrea = "Eritre";
var Estonia = "Estonya";
var Ethiopia = "Etiyopya";
var Fiji = "Fiji";
var Finland = "Finlandiya";
var France = "Fransa";
var Gabon = "Gabon";
var Gambia = "Gambia";
var Georgia = "Gürcistan";
var Germany = "Almanya";
var Ghana = "Gana";
var Gibraltar = "Cebelitarık";
var Greece = "Yunanistan";
var Greenland = "Grönland";
var Grenada = "Grenada";
var Guadeloupe = "Guadeloupe";
var Guam = "Guam";
var Guatemala = "Guatemala";
var Guernsey = "Guernsey";
var Guinea = "Gine";
var Guyana = "Guyana";
var Haiti = "Haiti";
var Honduras = "Honduras";
var Hungary = "Macaristan";
var Iceland = "İzlanda";
var India = "Hindistan";
var Indonesia = "Endonezya";
var Iraq = "Irak";
var Ireland = "İrlanda";
var Israel = "İsrail";
var Italy = "İtalya";
var Jamaica = "Jamaika";
var Japan = "Japonya";
var Jersey = "Jersey";
var Jordan = "Ürdün";
var Kazakhstan = "Kazakistan";
var Kenya = "Kenya";
var Kiribati = "Kiribati";
var Kuwait = "Kuveyt";
var Kyrgyzstan = "Kırgızistan";
var Latvia = "Letonya";
var Lebanon = "Lübnan";
var Lesotho = "Lesotho";
var Liberia = "Liberya";
var Libya = "Libya Arap Cumhuriyeti";
var Liechtenstein = "Lihtenştayn";
var Lithuania = "Litvanya";
var Luxembourg = "Lüksemburg";
var Macao = "Makao";
var Madagascar = "Madagaskar";
var Malawi = "Malavi";
var Malaysia = "Malezya";
var Maldives = "Maldivler";
var Mali = "Mali";
var Malta = "Malta";
var Martinique = "Martinik";
var Mauritania = "Moritanya";
var Mauritius = "Mauritius";
var Mayotte = "Mayotte";
var Mexico = "Meksika";
var Monaco = "Monako";
var Mongolia = "Moğolistan";
var Montenegro = "Karadağ";
var Montserrat = "Monserat";
var Morocco = "Fas";
var Mozambique = "Mozambik";
var Myanmar = "Myanmar";
var Namibia = "Namibya";
var Nauru = "Nauru";
var Nepal = "Nepal";
var Netherlands = "Hollanda";
var Nicaragua = "Nikaragua";
var Niger = "Nijer";
var Nigeria = "Nijerya";
var Niue = "Niue";
var Norway = "Norveç";
var Oman = "Umman";
var Pakistan = "Pakistan";
var Palau = "Palau";
var Panama = "Panama";
var Paraguay = "Paraguay";
var Peru = "Peru";
var Philippines = "Filipinler";
var Pitcairn = "Pitcairn";
var Poland = "Polonya";
var Portugal = "Portekiz";
var Qatar = "Katar";
var Romania = "Romanya";
var Rwanda = "Ruanda";
var Samoa = "Samoa";
var Senegal = "Senegal";
var Serbia = "Sırbistan";
var Seychelles = "Seyşeller";
var Singapore = "Singapur";
var Slovakia = "Slovakya";
var Slovenia = "Slovenya";
var Somalia = "Somali";
var Spain = "İspanya";
var Sudan = "Sudan";
var Suriname = "Surinam";
var Swaziland = "Swaziland";
var Sweden = "İsveç";
var Switzerland = "İsviçre";
var Taiwan = "Tayvan";
var Tajikistan = "Tacikistan";
var Thailand = "Tayland";
var Togo = "Togo";
var Tokelau = "Tokelau";
var Tonga = "Tonga";
var Tunisia = "Tunus";
var Turkey = "Türkiye";
var Turkmenistan = "Türkmenistan";
var Tuvalu = "Tuvalu";
var Uganda = "Uganda";
var Ukraine = "Ukrayna";
var Uruguay = "Uruguay";
var Uzbekistan = "Özbekistan";
var Vanuatu = "Vanuatu";
var Venezuela = "Venezuela";
var Yemen = "Yemen";
var Zambia = "Zambia";
var Zimbabwe = "Zimbabve";
var countries = {
	"Country or region": "Ülke veya bölge",
	"United States": "Amerika Birleşik Devletleri",
	Afghanistan: Afghanistan,
	"Åland Islands": "Åland Adaları",
	Albania: Albania,
	Algeria: Algeria,
	"American Samoa": "Amerikan Samoası",
	Andorra: Andorra,
	Angola: Angola,
	Anguilla: Anguilla,
	Antarctica: Antarctica,
	"Antigua and Barbuda": "Antigua ve Barbuda",
	Argentina: Argentina,
	Armenia: Armenia,
	Aruba: Aruba,
	Australia: Australia,
	Austria: Austria,
	Azerbaijan: Azerbaijan,
	Bahamas: Bahamas,
	Bahrain: Bahrain,
	Bangladesh: Bangladesh,
	Barbados: Barbados,
	Belarus: Belarus,
	Belgium: Belgium,
	Belize: Belize,
	Benin: Benin,
	Bermuda: Bermuda,
	Bhutan: Bhutan,
	Bolivia: Bolivia,
	"Bosnia and Herzegovina": "Bosna Hersek",
	Botswana: Botswana,
	"Bouvet Island": "Bouvet Adası",
	Brazil: Brazil,
	"British Indian Ocean Territory": "İngiliz Hint Okyanusu Bölgesi",
	"Brunei Darussalam": "Brunei Darüsselam",
	Bulgaria: Bulgaria,
	"Burkina Faso": "Burkina Faso",
	Burundi: Burundi,
	Cambodia: Cambodia,
	Cameroon: Cameroon,
	Canada: Canada,
	"Cape Verde": "Cape Verde",
	"Cayman Islands": "Cayman Adaları",
	"Central African Republic": "Orta Afrika Cumhuriyeti",
	Chad: Chad,
	Chile: Chile,
	China: China,
	"Christmas Island": "Christmas Adası",
	"Cocos (Keeling) Islands": "Cocos (Keeling) Adaları",
	Colombia: Colombia,
	Comoros: Comoros,
	Congo: Congo,
	"Congo, The Democratic Republic of The": "Demokratik Kongo Cumhuriyeti",
	"Cook Islands": "Cook Adaları",
	"Costa Rica": "Kosta Rika",
	"Côte d'Ivoire": "Fildişi Sahili",
	Croatia: Croatia,
	Cuba: Cuba,
	Cyprus: Cyprus,
	"Czech Republic": "Çek Cumhuriyeti",
	Denmark: Denmark,
	Djibouti: Djibouti,
	Dominica: Dominica,
	"Dominican Republic": "Dominik Cumhuriyeti",
	Ecuador: Ecuador,
	Egypt: Egypt,
	"El Salvador": "El Salvador",
	"Equatorial Guinea": "Ekvator Ginesi",
	Eritrea: Eritrea,
	Estonia: Estonia,
	Ethiopia: Ethiopia,
	"Falkland Islands (Malvinas)": "Falkland Adaları (Malvinas)",
	"Faroe Islands": "Faroe Adaları",
	Fiji: Fiji,
	Finland: Finland,
	France: France,
	"French Guiana": "Fransız Ginesi",
	"French Polynesia": "Fransız Polinezyası",
	"French Southern Territories": "Fransız Güney Bölgeleri",
	Gabon: Gabon,
	Gambia: Gambia,
	Georgia: Georgia,
	Germany: Germany,
	Ghana: Ghana,
	Gibraltar: Gibraltar,
	Greece: Greece,
	Greenland: Greenland,
	Grenada: Grenada,
	Guadeloupe: Guadeloupe,
	Guam: Guam,
	Guatemala: Guatemala,
	Guernsey: Guernsey,
	Guinea: Guinea,
	"Guinea-Bissau": "Guinea-Bissau",
	Guyana: Guyana,
	Haiti: Haiti,
	"Heard Island and McDonald Islands": "Heard Adası ve Mcdonald Adaları",
	"Holy See (Vatican City State)": "Papalık (Vatikan)",
	Honduras: Honduras,
	"Hong Kong": "Hong Kong",
	Hungary: Hungary,
	Iceland: Iceland,
	India: India,
	Indonesia: Indonesia,
	"Iran, Islamic Republic of": "İran İslam Cumhuriyeti",
	Iraq: Iraq,
	Ireland: Ireland,
	"Isle of Man": "Man Adası",
	Israel: Israel,
	Italy: Italy,
	Jamaica: Jamaica,
	Japan: Japan,
	Jersey: Jersey,
	Jordan: Jordan,
	Kazakhstan: Kazakhstan,
	Kenya: Kenya,
	Kiribati: Kiribati,
	"Korea, Democratic People’s Republic of": "Kore Demokratik Halk Cumhuriyeti",
	"Korea, Republic of": "Kore Cumhuriyeti",
	Kuwait: Kuwait,
	Kyrgyzstan: Kyrgyzstan,
	"Lao People's Democratic Republic": "Laos Demokratik Halk Cumhuriyeti",
	Latvia: Latvia,
	Lebanon: Lebanon,
	Lesotho: Lesotho,
	Liberia: Liberia,
	Libya: Libya,
	Liechtenstein: Liechtenstein,
	Lithuania: Lithuania,
	Luxembourg: Luxembourg,
	Macao: Macao,
	"Macedonia, The Former Yugoslav Republic of": "Makedonya Eski Yugoslav Cumhuriyeti",
	Madagascar: Madagascar,
	Malawi: Malawi,
	Malaysia: Malaysia,
	Maldives: Maldives,
	Mali: Mali,
	Malta: Malta,
	"Marshall Islands": "Marshall Adaları",
	Martinique: Martinique,
	Mauritania: Mauritania,
	Mauritius: Mauritius,
	Mayotte: Mayotte,
	Mexico: Mexico,
	"Micronesia, Federated States of": "Mikronezya Federal Devletleri",
	"Moldova, Republic of": "Moldova Cumhuriyeti",
	Monaco: Monaco,
	Mongolia: Mongolia,
	Montenegro: Montenegro,
	Montserrat: Montserrat,
	Morocco: Morocco,
	Mozambique: Mozambique,
	Myanmar: Myanmar,
	Namibia: Namibia,
	Nauru: Nauru,
	Nepal: Nepal,
	Netherlands: Netherlands,
	"Netherlands Antilles": "Hollanda Antilleri",
	"New Caledonia": "Yeni Kaledonya",
	"New Zealand": "Yeni Zelanda",
	Nicaragua: Nicaragua,
	Niger: Niger,
	Nigeria: Nigeria,
	Niue: Niue,
	"Norfolk Island": "Norfolk Adası",
	"Northern Mariana Islands": "Kuzey Mariana Adaları",
	Norway: Norway,
	Oman: Oman,
	Pakistan: Pakistan,
	Palau: Palau,
	"Palestine, State of": "İşgal Altındaki Filistin Toprakları",
	Panama: Panama,
	"Papua New Guinea": "Papua Yeni Gine",
	Paraguay: Paraguay,
	Peru: Peru,
	Philippines: Philippines,
	Pitcairn: Pitcairn,
	Poland: Poland,
	Portugal: Portugal,
	"Puerto Rico": "Porto Riko",
	Qatar: Qatar,
	"Réunion": "Réunion",
	Romania: Romania,
	"Russian Federation": "Rusya Federasyonu",
	Rwanda: Rwanda,
	"Saint Helena": "Saint Helena",
	"Saint Kitts and Nevis": "Saint Kitts ve Nevis",
	"Saint Lucia": "Saint Lucia",
	"Saint Pierre and Miquelon": "Saint Pierre ve Miquelon",
	"Saint Vincent and The Grenadines": "Saint Vincent ve Grenadinler",
	Samoa: Samoa,
	"San Marino": "San Marino",
	"Sao Tome and Principe": "Sao Tome ve Principe",
	"Saudi Arabia": "Suudi Arabistan",
	Senegal: Senegal,
	Serbia: Serbia,
	Seychelles: Seychelles,
	"Sierra Leone": "Sierra Leone",
	Singapore: Singapore,
	Slovakia: Slovakia,
	Slovenia: Slovenia,
	"Solomon Islands": "Solomon Adaları",
	Somalia: Somalia,
	"South Africa": "Güney Afrika",
	"South Georgia and The South Sandwich Islands": "Güney Georgia ve Güney Sandwich Adaları",
	Spain: Spain,
	"Sri Lanka": "Sri Lanka",
	Sudan: Sudan,
	Suriname: Suriname,
	"Svalbard and Jan Mayen": "Svalbard ve Jan Mayen",
	Swaziland: Swaziland,
	Sweden: Sweden,
	Switzerland: Switzerland,
	"Syrian Arab Republic": "Suriye Arap Cumhuriyeti",
	Taiwan: Taiwan,
	Tajikistan: Tajikistan,
	"Tanzania, United Republic of": "Tanzanya Birleşik Cumhuriyeti",
	Thailand: Thailand,
	"Timor-Leste": "Doğu Timor",
	Togo: Togo,
	Tokelau: Tokelau,
	Tonga: Tonga,
	"Trinidad and Tobago": "Trinidad ve Tobago",
	Tunisia: Tunisia,
	Turkey: Turkey,
	Turkmenistan: Turkmenistan,
	"Turks and Caicos Islands": "Turks ve Caicos Adaları",
	Tuvalu: Tuvalu,
	Uganda: Uganda,
	Ukraine: Ukraine,
	"United Arab Emirates": "Birleşik Arap Emirlikleri",
	"United Kingdom": "Birleşik Krallık",
	"United States Minor Outlying Islands": "Amerika Birleşik Devletleri Küçük Harici Adaları",
	Uruguay: Uruguay,
	Uzbekistan: Uzbekistan,
	Vanuatu: Vanuatu,
	Venezuela: Venezuela,
	"Viet Nam": "Vietnam",
	"Virgin Islands, British": "Britanya Virjin Adaları",
	"Virgin Islands, U.S.": "ABD Virjin Adaları",
	"Wallis and Futuna": "Wallis ve Futuna",
	"Western Sahara": "Batı Sahra",
	Yemen: Yemen,
	Zambia: Zambia,
	Zimbabwe: Zimbabwe
};

export { Afghanistan, Albania, Algeria, Andorra, Angola, Anguilla, Antarctica, Argentina, Armenia, Aruba, Australia, Austria, Azerbaijan, Bahamas, Bahrain, Bangladesh, Barbados, Belarus, Belgium, Belize, Benin, Bermuda, Bhutan, Bolivia, Botswana, Brazil, Bulgaria, Burundi, Cambodia, Cameroon, Canada, Chad, Chile, China, Colombia, Comoros, Congo, Croatia, Cuba, Cyprus, Denmark, Djibouti, Dominica, Ecuador, Egypt, Eritrea, Estonia, Ethiopia, Fiji, Finland, France, Gabon, Gambia, Georgia, Germany, Ghana, Gibraltar, Greece, Greenland, Grenada, Guadeloupe, Guam, Guatemala, Guernsey, Guinea, Guyana, Haiti, Honduras, Hungary, Iceland, India, Indonesia, Iraq, Ireland, Israel, Italy, Jamaica, Japan, Jersey, Jordan, Kazakhstan, Kenya, Kiribati, Kuwait, Kyrgyzstan, Latvia, Lebanon, Lesotho, Liberia, Libya, Liechtenstein, Lithuania, Luxembourg, Macao, Madagascar, Malawi, Malaysia, Maldives, Mali, Malta, Martinique, Mauritania, Mauritius, Mayotte, Mexico, Monaco, Mongolia, Montenegro, Montserrat, Morocco, Mozambique, Myanmar, Namibia, Nauru, Nepal, Netherlands, Nicaragua, Niger, Nigeria, Niue, Norway, Oman, Pakistan, Palau, Panama, Paraguay, Peru, Philippines, Pitcairn, Poland, Portugal, Qatar, Romania, Rwanda, Samoa, Senegal, Serbia, Seychelles, Singapore, Slovakia, Slovenia, Somalia, Spain, Sudan, Suriname, Swaziland, Sweden, Switzerland, Taiwan, Tajikistan, Thailand, Togo, Tokelau, Tonga, Tunisia, Turkey, Turkmenistan, Tuvalu, Uganda, Ukraine, Uruguay, Uzbekistan, Vanuatu, Venezuela, Yemen, Zambia, Zimbabwe, countries as default };
